// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"PowerAnytime_TheComp__5LaQJ"};